'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { PolicyDialogContent } from './PolicyDialogContent';
interface PolicyBottomDrawerProps {
  policyIdIdx?: string;
  isOpened: boolean;
  onClose: () => void;
}
export const PolicyBottomDrawer = t0 => {
  const $ = _c(16);
  const {
    policyIdIdx,
    isOpened,
    onClose
  } = t0;
  const onCloseRef = useRef(onClose);
  const timerRef = useRef(undefined);
  let t1;
  let t2;
  if ($[0] !== onClose) {
    t1 = () => {
      onCloseRef.current = onClose;
    };
    t2 = [onClose];
    $[0] = onClose;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const [requestedOpened, setRequestedOpened] = useState(isOpened);
  let t3;
  let t4;
  if ($[3] !== isOpened) {
    t3 = () => {
      if (isOpened) {
        clearTimeout(timerRef.current);
        setRequestedOpened(true);
      } else {
        setRequestedOpened(false);
      }
    };
    t4 = [isOpened];
    $[3] = isOpened;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== requestedOpened) {
    t5 = () => {
      if (!requestedOpened) {
        timerRef.current = setTimeout(() => {
          onCloseRef.current();
        }, 300);
        return () => {
          clearTimeout(timerRef.current);
        };
      }
    };
    t6 = [requestedOpened];
    $[6] = requestedOpened;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setRequestedOpened(false);
    t8 = {
      modal: "max-w-[800px]"
    };
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== policyIdIdx) {
    t9 = <PolicyDialogContent policyIdIdx={policyIdIdx} />;
    $[11] = policyIdIdx;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== requestedOpened || $[14] !== t9) {
    t10 = <ResponsiveDialog modalHeader={"\uC815\uCC45"} opened={requestedOpened} onClose={t7} className={t8} drawerType="bottom">{t9}</ResponsiveDialog>;
    $[13] = requestedOpened;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};